import React, { useState, useEffect } from 'react';
import { Row, Button } from 'antd';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import SkillsList from './skills-list';
import { NewSkillForm } from './new-skill-form';
import { Title } from './styles';
import { useList } from '../../hooks';

const ButtonWrapper = styled.div`
	text-align: center;
	margin-top: 12px;
	height: 32px;
	line-height: 32px;
`;

const AddSkillButton = ({ btnText, style, onClick }) => (
	<ButtonWrapper style={style}>
		<Button className="ta-ant-btn sm" onClick={onClick}>
			{btnText || 'Add skill'}
		</Button>
	</ButtonWrapper>
);

export function SkillSelector({
	title,
	dataSource,
	onItemAdd,
	onItemRemove,
	skillForm,
	proficiencyLevels,
	defaultProficiencyLevel,
	showPlus = true,
	showProficiencyLevels = true,
	skillsOptions,
	addBtnText,
	emptyListText,
	className,
	loadMoreBtn,
	onChange,
	skillModalFormTitle,
	visibleSkillsCount = -1
}: any): any {
	const theme = useTheme();
	let [showModal, setShowModal] = useState(false);
	let [skills, onSkillAdd, onSkillRemove, _, setSkills] = useList(dataSource, {
		onAdd: onItemAdd,
		onRemove: onItemRemove
	});

	useEffect(() => {
		setSkills(dataSource);
	}, [dataSource]);

	useEffect(() => {
		onChange && onChange(skills);
	}, [skills]);

	return (
		<div className={`pb-4 ${className}`}>
			{title && <label className="ta-input-label mb-2">{title}: </label>}
			<SkillsList
				skills={skills}
				emptyText={emptyListText || 'No Data'}
				proficiencyLevels={proficiencyLevels}
				itemsRemovable
				onItemRemove={index => {
					onSkillRemove(index);
				}}
				showPlus={showPlus}
				showProficiencyLevels={showProficiencyLevels}
				visibleCount={visibleSkillsCount}
			/>
			{/* <AddSkillButton btnText={addBtnText || 'Add'} onClick={() => setShowModal(true)} /> */}
			<NewSkillForm
				visible={showModal}
				onAdd={skill => {
					onSkillAdd(skill);
				}}
				onCancel={() => setShowModal(false)}
				proficiencyLevels={proficiencyLevels}
				skillsOptions={skillsOptions}
				skillForm={skillForm}
				defaultProficiencyLevel={defaultProficiencyLevel}
				showPlus={showPlus}
				showProficiencyLevels={showProficiencyLevels}
				skillModalFormTitle={skillModalFormTitle}
			/>
			{loadMoreBtn || (
				<Title
					button
					className="py-2"
					iconType="plus-circle"
					color={theme.TA_GREEN}
					onClick={() => setShowModal(true)}
				>
					{addBtnText || 'Add'}
				</Title>
			)}
		</div>
	);
}

// export default SkillModal;
